<style>
.btn-transparent {
  background-color: transparent !important;
}
</style>
<template>
  <button
    class="btn btn-sm btn-block btn-transparent text-left"
    type="button"
    @click="productoClickSku($event)"
  >
    {{ producto.sku }}
  </button>
</template>

<script>
import ProductosService from "@/services/catalogos/ProductosService";

export default {
  components: {},
  data() {
    return {
      current: {},
    };
  },
  props: ["producto"],
  computed: {},
  mounted() {
    let self = this;
  },
  methods: {
    showPopover(event) {
      let self = this;
      let content =
        `<div class="profile-tile">
                    <a class="profile-tile-box" href="users_profile_small.html">
                      <div class="pt-avatar-w">
                        <img alt="" src="img/avatar1.jpg">
                      </div>
                      <div class="pt-user-name">
                        ` +
        self.producto.nombre +
        `
                      </div>
                    </a>
                    <div class="profile-tile-meta">
                      <ul>
                        <li>
                          Categoria: <strong>` + self.producto.categoria + `</strong>
                        </li>
                        <li>
                          Permitir Compra: <strong>` + self.producto.permitir_compra + `</strong>
                        </li>
                        <li>
                          Permitir Venta: <strong>` + self.producto.permitir_venta + `</strong>
                        </li>
                      </ul>
                      <div class="pt-btn">
                        <a class="btn btn-success btn-sm" href="/cat/productos/editar/` + self.producto.sku + `">Ver Producto</a>
                      </div>
                    </div>
                  </div>`;
      $(event.target).popover({
        title: self.producto.sku,
        content: content,
        html: true,
        trigger: "focus",
        placement: "top",
      });
      $(event.target).popover("show");
    },
    productoClickSku(e) {
      let self = this;
      /*ProductosService.getById(self.producto.sku, {}, false).then((response) => {
        self.current = response.data;
        */self.showPopover(e);
      //});
    },
  },
};
</script>
